import { observable } from "mobx";
import { copy } from "../utils/data";

/*
 This is the registration data expected by the web service used to create an account.
 You can add additional fields if you need them for the UI rendering but this is the data
 that will be stored.
 The app must be set to "seeker" (not case sensitive) so do not change that
*/

export class Registration {
  @observable email: string;
  @observable confirmEmail: string;
  @observable password: string;
  @observable confirmPassword: string;
  @observable firstName: string;
  @observable lastName: string;
  @observable zip: string;
  @observable phone: string;
  @observable dob: Date;
  @observable vetStatus: number;
  @observable howHeard: number;
  @observable ethnicity: number;
  @observable gender: number;
  @observable language: string;
  @observable app: string;
  @observable howHeardOther: string;
  @observable region: string;
  @observable regionSrc: string;
  @observable militaryStatus: number;

  constructor(lang: string) {
    this.app = "Seeker";
    this.language = lang;
    this.region = this.regionSrc = this.howHeardOther = "";
  }

  resetAll = (): void =>{
    this.email = this.confirmEmail = this.password = this.confirmPassword = this.firstName = this.lastName = this.zip = this.phone = this.region = this.regionSrc = "";
    this.dob = new Date;
    this.howHeard = this.vetStatus = this.militaryStatus = this.ethnicity = this.gender = 0;
  }
}

export interface IRegistrationError {
  message: string;
  modelState: Array<string>;
}


// WEBPACK FOOTER //
// ./src/models/registration.ts